export default __webpack_public_path__ + "static/media/discounts-15off35-image.11611b62.svg";